import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
const SvgIconSkipPrevious = (props) => (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", focusable: false, ...props, children: _jsx("path", { fillRule: "evenodd", d: "M14 7L7 12L14 17V7ZM17 12V7H15V17H17V12Z", clipRule: "evenodd" }) }));
const Memo = memo(SvgIconSkipPrevious);
export default Memo;
//# sourceMappingURL=IconSkipPrevious.js.map